{
	"beforePhoto": "Before photo {{var0}}"
}
